"use client"

import * as React from "react"
import {
  ChakraProvider,
  createSystem,
  defaultConfig,
  defaultSystem,
  defineRecipe,
} from "@chakra-ui/react"

import { ColorModeProvider } from "./color-mode.js"

const buttonRecipe = defineRecipe({
  variants: {
    variant: {
      outline: {
        bg: "transparent",
        color: "#6BD9F2",
        border: "1px solid #6BD9F2",
        width: "100%",
        borderRadius: "10px",
        height: "50px",
        marginTop: "20px",
        marginBottom: "20px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, .35)",
        _hover: {
          border: "1px solid #A1D9E5",
          color: "#A1D9E5",
        },
      },
      solid: {
        bg: " #6BD9F2",
        color: " #30343B",
        width: "100%",
        borderRadius: "10px",
        height: "50px",
        marginTop: "20px",
        marginBottom: "20px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, .35)",
        _hover: {
          bg: "#A1D9E5",
        },
      },
    },
  },
})

const system = createSystem(defaultConfig, {
  theme: {
    recipes: { button: buttonRecipe },
  },
})

export function Provider(props) {
  return (
    <ChakraProvider value={system ?? defaultSystem}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  )
}

